import React from 'react'
import { Bookmark } from 'lucide-react'

const CompanyShortlists = () => (
  <div className="space-y-6">
    <div className="flex items-center">
      <Bookmark className="w-6 h-6 text-primary-600 mr-2" />
      <h1 className="text-2xl font-bold text-secondary-900">Shortlists</h1>
    </div>
    <div className="card p-6 text-secondary-600">Shortlists placeholder</div>
  </div>
)

export default CompanyShortlists


